import * as React from 'react';

import * as classnames from 'classnames';

import { Button, Grid, Spacer, Typography } from '@emburse/ui-core';

import * as style from './CelebrationState.styl';

interface ICelebrationStateProps {
  className?: string;
  centered?: boolean;
  headerText?: string;
  bodyText?: string;
  buttonText?: string;
  onClick?: () => void;
}

export const CelebrationState: React.FC<ICelebrationStateProps> = ({ className, centered, headerText, bodyText, buttonText, onClick }) => {
  return (
    <Grid
      container
      direction="column"
      spacing={1}
      sx={{ height: '100%', maxWidth: '754px' }}
      wrap="nowrap"
      className={classnames(style.global, className)}
    >
      <Grid item className="layout">
        <Spacer size={32} />
        <Grid container alignItems="center" wrap="nowrap" justifyContent="center" direction="column">
          <Grid item>
            <img style={{ height: '100%' }} src={'img/celebrate.svg'} alt="welcome" />
          </Grid>
        </Grid>
        {headerText && (
          <>
            <Typography variant="h4" style={{ alignSelf: 'flex-start' }} {...(centered ? { align: 'center' } : {})}>
              {headerText}
            </Typography>
            <Spacer size={32} />
          </>
        )}
        {bodyText && (
          <>
            <Typography variant="body1" style={{ alignSelf: 'flex-start' }} {...(centered ? { align: 'center' } : {})}>
              {bodyText}
            </Typography>
            <Spacer size={32} />
          </>
        )}
        {buttonText && (
          <div className={classnames('flex', { 'jc-c': centered })}>
            <Button onClick={onClick} className="signup-finish">
              {buttonText}
            </Button>
          </div>
        )}
      </Grid>
      <Grid item xs>
        <Spacer size={4} />
      </Grid>
    </Grid>
  );
};
